// Placeholder "Send" arrow icon (mobile footer) — swap for the exported Zeplin asset.
const sendArrow = `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g class="icon-color" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="19" x2="12" y2="6"/>
      <polyline points="6 12 12 6 18 12"/>
    </g>
  </svg>
`

export default sendArrow
